import * as apiConstants from './apiConstants';


class ApiOperation {

    /**
     * @type {{}}
     * @private
     */
    headers = {};

    /**
     * @type {any|null}
     * @private
     */
    body = null;


    /**
     * @returns {object|any} Body
     */
    getBody() {

        return this.body;
    }


    /**
     * @param body {*} Body
     */
    setBody(body) {

        this.body = body;
    }


    /**
     * @returns {boolean} True if body is truthy
     */
    hasBody() {

        return !!this.body;
    }


    /**
     * @param name {string} Http header name
     * @param defaultValue {any|null} Default value returned in case there is no header for the given name
     */
    getHeader(name, defaultValue = null) {

        let headerName = name.toLowerCase();
        if (this.headers.hasOwnProperty(headerName)) {

            return this.headers[headerName];
        }

        return defaultValue;
    }


    /**
     * @param name {string} Http header name
     * @param value {string} Http header value
     */
    setHeader(name, value) {

        this.headers[name.toLowerCase()] = value;
    }


    /**
     * @returns {object} Http header name to value object
     */
    getHeaders() {

        return this.headers;
    }


    /**
     * @param headers {object} Http header name to value object
     */
    setHeaders(headers) {

        Object.entries(headers)
            .forEach(([name, value]) => {
                this.headers[name.toLowerCase()] = value;
            });
    }


    /**
     * @returns {boolean} True if Content-Type header is application/json
     */
    isJson() {

        return this.getHeader(apiConstants.HTTP_HEADER_CONTENT_TYPE, '')
            .indexOf(apiConstants.HTTP_HEADER_CONTENT_TYPE_JSON) !== -1;
    }


    /**
     * @returns {boolean} True if Content-Type header is application/x-www-form-urlencoded
     */
    isForm() {

        return this.getHeader(apiConstants.HTTP_HEADER_CONTENT_TYPE, '')
            .indexOf(apiConstants.HTTP_HEADER_CONTENT_TYPE_FORM) !== -1;
    }


    /**
     * @return {object} Loggable output
     */
    toLog() {

        return {
            headers: this.getHeaders(),
            body: this.getBody()
        };
    }
}

export default ApiOperation;
